const FooterSection = () => {
  return (
    <footer className="section-padding bg-background border-t border-border/50">
      <div className="section-container">
        {/* From the Founder */}
        <div className="max-w-2xl mb-12">
          <h3 className="text-sm font-semibold uppercase tracking-widest text-primary mb-4">
            From the Founder
          </h3>
          <blockquote className="text-muted-foreground leading-relaxed space-y-4">
            <p>
              I built this because I have the same problem. 25+ years of startup ideas scattered across notebooks, apps, and my own head. I wanted something dead simple that let me capture fast, search everything, and finally make progress on the ideas worth pursuing.
            </p>
            <p>
              If that sounds like you, get on the list.
            </p>
          </blockquote>
          <p className="mt-4 font-medium text-foreground">
            — Nate Ritter, Founder Labs
          </p>
        </div>
        
        {/* Footer links */}
        <div className="pt-8 border-t border-border/50 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <a 
            href="https://founderlabs.io" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-primary transition-colors"
          >
            founderlabs.io
          </a>
          <p>© 2025 Founder Labs. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
